interface IStorage {
  get<TData>(itemName: string): TData | undefined;
  set<TData>(itemName: string, item: TData): void;
  remove(itemName: string): void;
}

interface IExpiringStorageServiceData<TData> {
  userId: string;
  expiresAt: string;
  data: TData;
}

export interface IExpiringUserStorageServiceConfig {
  storage: IStorage;
  userId: string;
  ttl: number;
}

export default class ExpiringUserStorageService {
  constructor(private config: IExpiringUserStorageServiceConfig) {}

  public get<TData>(itemName: string): TData | undefined {
    const item = this.config.storage.get<IExpiringStorageServiceData<TData>>(itemName);

    if (!item || item.userId !== this.config.userId || new Date(item.expiresAt) <= new Date()) {
      this.remove(itemName);
      return;
    }

    return item.data;
  }

  public set<TData>(itemName: string, item: TData) {
    this.config.storage.set<IExpiringStorageServiceData<TData>>(itemName, {
      userId: this.config.userId,
      expiresAt: new Date(Date.now() + this.config.ttl).toJSON(),
      data: item,
    });
  }

  public remove(itemName: string) {
    this.config.storage.remove(itemName);
  }
}
